import * as React from "react";
import { singleton } from "logic/singleton";
const WatchlistStatusContext = React.createContext(void 0);
export default singleton("contexts.WatchlistStatusContext", () => WatchlistStatusContext);
